type AuthLocalStorageKeys = 'auth/itOverridePermissions' | 'auth/itOverrideUser';

export const fetchAuthLocalStorageValue = <T>(key: AuthLocalStorageKeys): T | undefined =>
  localStorage.getItem(key) ? (JSON.parse(localStorage.getItem(key)!) as T) : undefined;

export const removeAuthLocalStorageValue = (key: AuthLocalStorageKeys) => localStorage.removeItem(key);

export const setAuthLocalStorageValue = <T>(key: AuthLocalStorageKeys, value: T): void =>
  localStorage.setItem(key, JSON.stringify(value));
